
<template>
  <div></div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("oidcStore");

export default {
  name: "OidcCallback",
  methods: {
    ...mapActions(["oidcSignInCallback"])
  },
  mounted() {
    this.oidcSignInCallback()
      .then(redirectPath => {
        this.$router.push(redirectPath);
      })
      .catch(() => {
        this.$router.push("/"); // TODO Handle errors any way you want
      });
  }
};
</script>